<template>
  <div class="outline">
    <Banner></Banner>
  </div>
</template>

<script>
import TopButtom from "@/components/common/TopButtom.vue";
import Banner from "../../components/common/banner";
export default {
  name: "OutLine",
  components: { Banner, TopButtom },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    openTypeLise(type) {
      let name = "";
      if (type == 1) {
        name = "TabApage";
      } else if (type == 2) {
        name = "TabBpage";
      } else if (type == 3) {
        name = "TabCpage";
      } else if (type == 4) {
        name = "TabDpage";
      }
      this.$store.commit("setTabPage", type);
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/outline/index.vue